function settingFlagEnabled(settings, key) {
  const row = settings?.find((item) => item.key === key);
  const value = row?.value;
  return value === "1" || value === 1 || value === true || value === "true";
}

/** هل إعداد «إيقاف تقديم الإجازات» مفعّل؟ */
export function isVacationSubmitDisabled(settings) {
  return settingFlagEnabled(settings, "admin.disable_vacation_submit");
}

/** هل يُسمح بتعديل وحذف الإجازات بعد اعتماد الإدارة أو الشؤون؟ */
export function isEditApprovedVacationsAllowed(settings) {
  return settingFlagEnabled(settings, "admin.allow_edit_approved_vacations");
}

/** صفحة مهامي — هل يُسمح بتعديل/حذف هذا الطلب؟ */
export function canMutateTasksTableVacation(record, settings) {
  const allPending =
    record?.dept_manager === "في الانتظار" &&
    record?.gerenal_sec === "في الانتظار" &&
    record?.hr_manager === "في الانتظار";
  if (allPending) {
    return true;
  }
  if (!isEditApprovedVacationsAllowed(settings)) {
    return false;
  }
  if (
    record?.dept_manager === "مرفوضة" ||
    record?.hr_manager === "مرفوضة" ||
    record?.gerenal_sec === "مرفوضة"
  ) {
    return false;
  }
  return (
    record?.dept_manager === "معتمدة" || record?.hr_manager === "معتمدة"
  );
}

/** سجل الحضور — هل يُسمح بتعديل/حذف هذه الإجازة؟ */
export function canMutateAttendanceVacation(vac, settings) {
  const status = Number(vac?.accepted ?? vac?.vac_status ?? 0);
  if (status === 3 || status === 4) {
    return false;
  }
  if (!status) {
    return true;
  }
  if (!isEditApprovedVacationsAllowed(settings)) {
    return status !== 2;
  }
  return status === 1 || status === 2;
}
